import { Tabs, TabsContent, TabsList, TabsTrigger } from '@servicetim/ui/components';
import { CommentsPanel } from './comments';
import { HistoryPanel } from './history';

/** Bottom of the detail screen: Comments | History. */
export function ActivityTabs() {
  return (
    <section aria-label="Activity" className="space-y-2">
      <h2 className="font-semibold text-fg text-sm">Activity</h2>
      <Tabs defaultValue="comments">
        <TabsList>
          <TabsTrigger value="comments">Comments</TabsTrigger>
          <TabsTrigger value="history">History</TabsTrigger>
        </TabsList>
        <TabsContent value="comments">
          <CommentsPanel />
        </TabsContent>
        <TabsContent value="history">
          <HistoryPanel />
        </TabsContent>
      </Tabs>
    </section>
  );
}
